<template>
  <div class="freecases-page pk-account-panel">
    <section class="freecases-hero">
      <div>
        <span>福利箱子</span>
        <h1>免费 Roll 房</h1>
        <p>官方和主播房间会在这里展示。奖池、截止时间和奖品以房间页面展示为准。</p>
      </div>
      <img src="../assets/hotpizza/hp-case-orange.png" alt="" />
    </section>

    <section class="freecases-toolbar">
      <div class="tabs">
        <button :class="{ active: activeName === 'first' }" @click="switchTab('first')">全部房间</button>
        <button :class="{ active: activeName === 'second' }" @click="switchTab('second')">我参与的</button>
      </div>
      <button class="refresh-btn" @click="activeName === 'first' ? getList() : getMyList()">刷新</button>
    </section>

    <section class="room-grid">
      <article v-for="item in activeList" :key="item.id" class="room-card" :class="{ ended: item.status == 2 }">
        <div class="room-cover">
          <img :src="item.img || defaultRoomImg" alt="" @error="setImageFallback($event, defaultRoomImg)" />
          <span>{{ item.type == 1 ? "官方" : "主播" }}</span>
          <em>{{ item.status == 1 ? "进行中" : "已结束" }}</em>
        </div>
        <div class="room-main">
          <h2>{{ item.room_name }}</h2>
          <div class="room-stats">
            <div>
              <span>奖池</span>
              <strong>{{ moneyText(item.pool) }} <i></i></strong>
            </div>
            <div>
              <span>件数</span>
              <strong>{{ item.count || 0 }}</strong>
            </div>
            <div v-if="item.type != 1">
              <span>人数</span>
              <strong>{{ item.person_num || 0 }}</strong>
            </div>
          </div>
          <div class="prize-strip">
            <div v-for="skin in item.skin_list" :key="skin.id" class="prize-item">
              <img :src="skin.imageUrl || defaultPrizeImg" alt="" @error="setImageFallback($event, defaultPrizeImg)" />
              <span>{{ moneyText(skin.price) }}</span>
            </div>
          </div>
          <div class="room-foot">
            <span>开奖时间 {{ item.run_lottery_time }}</span>
            <button @click="jionRoom(item.id)">{{ item.status == 1 ? "查看房间" : "查看结果" }}</button>
          </div>
        </div>
      </article>
    </section>

    <div v-if="!activeList.length" class="empty-card">暂无房间数据。</div>
  </div>
</template>

<script>
export default {
  props: ["yidongmenu", "showNav", "openHongbao"],
  data() {
    return {
      activeName: "first",
      list: [],
      list1: [],
      defaultRoomImg: require("../assets/hotpizza/hp-case-purple-transparent.png"),
      defaultPrizeImg: require("../assets/hotpizza/hp-ak-green.png"),
      skinImageCache: {
        1775: require("../assets/skin-cache/arena-1775.png"),
        703: require("../assets/skin-cache/arena-703.png"),
        1758: require("../assets/skin-cache/arena-1758.png"),
        1540: require("../assets/skin-cache/arena-1540.png"),
        473: require("../assets/skin-cache/arena-473.png"),
        1146: require("../assets/skin-cache/arena-1146.png"),
      },
    };
  },
  computed: {
    activeList() {
      return this.activeName === "first" ? this.list : this.list1;
    },
    loggedIn() {
      return Boolean(this.$store.state.token || localStorage.getItem("token"));
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    switchTab(tab) {
      if (tab === "second" && !this.loggedIn) {
        this.openLogin();
        return;
      }
      this.activeName = tab;
      if (tab === "first") {
        this.getList();
      } else {
        this.getMyList();
      }
    },
    getList() {
      this.$axios.post("index/Free/freeRoomList", this.$qs.stringify({ page: 1, pageSize: 50 })).then((res) => {
        if (res.data.status == 1) {
          this.list = this.normalizeRooms(res.data.data.list);
        }
      });
    },
    getMyList() {
      if (!this.loggedIn) {
        this.openLogin();
        return;
      }
      this.$axios.post("index/Free/myFreeRoom", this.$qs.stringify({ page: 1, pageSize: 50 })).then((res) => {
        if (res.data.status == 1) {
          this.list1 = this.normalizeRooms(res.data.data.list);
        } else {
          this.list1 = [];
        }
      });
    },
    normalizeRooms(list) {
      for (let i = 0; i < list.length; i++) {
        list[i].person_num = list[i].person_num || 0;
        list[i].count = list[i].count || 0;
        list[i].pool = list[i].pool || 0;
        list[i].img = this.stableImage(list[i].img, this.defaultRoomImg);
        const skins = list[i].skin_list || [];
        for (let j = 0; j < skins.length; j++) {
          skins[j].imageUrl = this.skinImageCache[skins[j].id] || this.stableImage(skins[j].imageUrl, this.defaultPrizeImg);
        }
      }
      return list;
    },
    jionRoom(id) {
      if (!this.loggedIn) {
        this.openLogin();
        return;
      }
      this.$router.push({ path: "/ArenaRoom", query: { id } });
    },
    openLogin() {
      this.$store.commit("getLogin", true);
    },
    moneyText(value) {
      return Number(value || 0).toFixed(2);
    },
    stableImage(value, fallback) {
      if (!value) return fallback;
      if (value.indexOf("http://") === 0) return fallback;
      if (value.indexOf("https://img.zbt.com") === 0) return fallback;
      if (value.indexOf("csgoapi.akaifa998.icu") !== -1) return fallback;
      if (value.indexOf("standoffi.oss-cn-hongkong.aliyuncs.com") !== -1) return fallback;
      return value;
    },
    setImageFallback(event, fallback) {
      event.target.src = fallback;
    },
  },
};
</script>

<style lang="less" scoped>
.freecases-page {
  min-height: calc(100vh - 198px);
  padding: 34px 34px 90px;
  color: #f5f7ff;
  background:
    radial-gradient(circle at 46% 0, rgba(255, 138, 31, 0.16), transparent 30%),
    radial-gradient(circle at 84% 28%, rgba(0, 217, 255, 0.1), transparent 28%),
    linear-gradient(180deg, #1f212d 0%, #171923 100%);
}

button {
  font-family: inherit;
  cursor: pointer;
}

.freecases-hero,
.freecases-toolbar,
.room-grid,
.empty-card {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.freecases-hero {
  min-height: 286px;
  padding: 42px 54px;
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 24px;
  align-items: center;
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  background:
    linear-gradient(130deg, rgba(41, 43, 58, 0.96), rgba(24, 26, 36, 0.98)),
    url("../assets/new/task_bg.png") center / cover;
  border: 1px solid rgba(255, 132, 31, 0.28);
  box-shadow: 0 26px 80px rgba(0, 0, 0, 0.34);
}

.freecases-hero::after {
  content: "";
  width: 760px;
  height: 280px;
  position: absolute;
  right: -160px;
  bottom: -160px;
  border-radius: 50%;
  background: radial-gradient(ellipse, rgba(255, 138, 0, 0.38), transparent 66%);
}

.freecases-hero > div,
.freecases-hero img {
  position: relative;
  z-index: 1;
}

.freecases-hero span {
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
}

.freecases-hero h1 {
  margin: 12px 0 14px;
  font-size: 62px;
  line-height: 0.98;
  font-weight: 1000;
}

.freecases-hero p {
  max-width: 700px;
  color: #aeb6c8;
  font-size: 17px;
  line-height: 1.8;
  font-weight: 800;
}

.freecases-hero img {
  width: 280px;
  justify-self: center;
  filter: drop-shadow(0 28px 38px rgba(0, 0, 0, 0.48));
}

.freecases-toolbar {
  margin-top: 22px;
  padding: 14px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  border-radius: 12px;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.tabs {
  display: flex;
  gap: 10px;
}

.tabs button,
.refresh-btn,
.room-foot button {
  height: 42px;
  padding: 0 20px;
  color: #f4f6ff;
  background: #303342;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 7px;
  font-weight: 1000;
}

.tabs button.active,
.room-foot button {
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
}

.room-grid {
  margin-top: 22px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  gap: 16px;
}

.room-card {
  overflow: hidden;
  border-radius: 14px;
  background: linear-gradient(180deg, #2b2e3d, #242735);
  border: 1px solid rgba(255, 138, 0, 0.2);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035), 0 16px 44px rgba(0, 0, 0, 0.24);
}

.room-card.ended {
  filter: saturate(0.74);
}

.room-cover {
  height: 124px;
  position: relative;
  overflow: hidden;
  background: radial-gradient(circle at 50% 30%, rgba(255, 138, 0, 0.24), transparent 62%), #1b1d28;
}

.room-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.42;
}

.room-cover span,
.room-cover em {
  position: absolute;
  top: 14px;
  padding: 5px 10px;
  border-radius: 99px;
  font-size: 12px;
  font-style: normal;
  font-weight: 1000;
}

.room-cover span {
  left: 14px;
  color: #151620;
  background: #ffb11f;
}

.room-cover em {
  right: 14px;
  color: #e9faff;
  background: rgba(0, 217, 255, 0.18);
  border: 1px solid rgba(0, 217, 255, 0.28);
}

.room-main {
  padding: 18px;
}

.room-main h2 {
  margin: 0;
  overflow: hidden;
  color: #f8fbff;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 24px;
  font-weight: 1000;
}

.room-stats {
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.room-stats div {
  padding: 12px;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.055);
}

.room-stats span {
  color: #8f98ab;
  font-size: 12px;
  font-weight: 900;
}

.room-stats strong {
  margin-top: 7px;
  display: flex;
  align-items: center;
  gap: 5px;
  color: #f8fbff;
  font-size: 18px;
  font-weight: 1000;
}

.room-stats i {
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.prize-strip {
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.prize-item {
  min-height: 86px;
  position: relative;
  display: grid;
  place-items: center;
  border-radius: 8px;
  background: radial-gradient(circle at 50% 40%, rgba(129, 73, 255, 0.28), transparent 62%), #202330;
  border: 1px solid rgba(255, 255, 255, 0.055);
}

.prize-item img {
  max-width: 94px;
  max-height: 62px;
  object-fit: contain;
  filter: drop-shadow(0 12px 16px rgba(0, 0, 0, 0.42));
}

.prize-item span {
  position: absolute;
  left: 8px;
  bottom: 7px;
  color: #ffd764;
  font-size: 12px;
  font-weight: 1000;
}

.room-foot {
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.room-foot span {
  color: #9aa3b8;
  font-size: 13px;
  font-weight: 900;
}

.empty-card {
  margin-top: 18px;
  padding: 34px 18px;
  color: #929bad;
  text-align: center;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.055);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 800;
}

@media screen and (max-width: 980px) {
  .freecases-page {
    padding: 20px 12px 64px;
  }

  .freecases-hero {
    grid-template-columns: 1fr;
    padding: 34px 24px;
  }

  .freecases-hero h1 {
    font-size: 46px;
  }

  .room-grid {
    grid-template-columns: 1fr;
  }

  .freecases-toolbar,
  .room-foot {
    align-items: stretch;
    flex-direction: column;
  }
}
</style>

<style lang="less">
.freecases-page.pk-account-panel {
  padding: 32px 28px 96px !important;
}

.freecases-page.pk-account-panel .freecases-hero,
.freecases-page.pk-account-panel .freecases-toolbar,
.freecases-page.pk-account-panel .room-grid,
.freecases-page.pk-account-panel .empty-card {
  width: calc(100% - 24px) !important;
  max-width: 1540px !important;
}

.freecases-page.pk-account-panel .freecases-hero {
  min-height: 320px !important;
  border-color: rgba(255, 132, 31, 0.38) !important;
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(255, 224, 170, 0.08) !important;
}

.freecases-page.pk-account-panel .freecases-hero img {
  width: 330px !important;
  filter:
    drop-shadow(0 30px 38px rgba(0, 0, 0, 0.5))
    drop-shadow(0 0 24px rgba(255, 138, 0, 0.24)) !important;
}

.freecases-page.pk-account-panel .room-grid {
  grid-template-columns: repeat(auto-fit, minmax(430px, 1fr)) !important;
  gap: 18px !important;
}

.freecases-page.pk-account-panel .room-card {
  border-color: rgba(255, 138, 0, 0.28) !important;
}

.freecases-page.pk-account-panel .room-cover {
  height: 154px !important;
}

.freecases-page.pk-account-panel .prize-strip {
  min-height: 92px !important;
}

.freecases-page.pk-account-panel .prize-item img {
  max-height: 62px !important;
}

@media screen and (max-width: 980px) {
  .freecases-page.pk-account-panel {
    padding: 18px 12px 58px !important;
  }

  .freecases-page.pk-account-panel .freecases-hero,
  .freecases-page.pk-account-panel .freecases-toolbar,
  .freecases-page.pk-account-panel .room-grid,
  .freecases-page.pk-account-panel .empty-card {
    width: 100% !important;
  }

  .freecases-page.pk-account-panel .room-grid {
    grid-template-columns: 1fr !important;
  }
}

/* 2026-07-05 exact internal pass: free cases rooms. */
.freecases-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  padding: 24px 24px 96px !important;
  background:
    radial-gradient(ellipse at 50% 170px, rgba(255, 138, 31, 0.08), transparent 420px),
    linear-gradient(180deg, #20222f 0, #1c1d29 420px, #171923 100%) !important;
}

.freecases-page.pk-account-panel .freecases-hero,
.freecases-page.pk-account-panel .freecases-toolbar,
.freecases-page.pk-account-panel .room-grid,
.freecases-page.pk-account-panel .empty-card {
  width: 100% !important;
  max-width: none !important;
}

.freecases-page.pk-account-panel .freecases-hero {
  min-height: 276px !important;
  padding: 30px 38px !important;
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
  background:
    radial-gradient(ellipse at 74% 52%, rgba(255, 138, 31, 0.14), transparent 48%),
    #20222f !important;
  box-shadow: none !important;
}

.freecases-page.pk-account-panel .hero-copy h1 {
  color: #f4ead8 !important;
  font-size: 52px !important;
}

.freecases-page.pk-account-panel .freecases-toolbar,
.freecases-page.pk-account-panel .room-card,
.freecases-page.pk-account-panel .empty-card {
  border-color: #2b2d3c !important;
  background: #20222f !important;
  border-radius: 8px !important;
}

.freecases-page.pk-account-panel .room-grid {
  grid-template-columns: repeat(auto-fit, minmax(390px, 1fr)) !important;
  gap: 12px !important;
}

.freecases-page.pk-account-panel .room-cover {
  height: 138px !important;
}

.freecases-page.pk-account-panel .prize-strip {
  gap: 6px !important;
}
</style>
